module.exports = __webpack_public_path__ + "img/logo.5a67e416.png";